import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useAssistantVariant } from "#contexts/AssistantVariantContext.ts";
import { WL_APP_SKILLS_PATH, wlAppSkillPath } from "#features/conversations/utils/wlAppPaths.ts";

// Where the panel links wl-app pages. Only the unified assistant, inside wl-app, has wl-app pages for a card to link
// skills and people to, or for the skill picker to send the user to; a member's card builds their page's address once
// the member is found.
export const useWlAppLinks = () => {
    const { wlAppBaseUrl } = useEnvironmentVariables();
    const linksToWlApp = useAssistantVariant() === "unified";

    return {
        linksToProfile: linksToWlApp,
        skillPageHref: (slug: string) => (linksToWlApp ? `${wlAppBaseUrl}${wlAppSkillPath(slug)}` : undefined),
        skillsPageHref: linksToWlApp ? `${wlAppBaseUrl}${WL_APP_SKILLS_PATH}` : undefined
    };
};
